import { render, staticRenderFns } from "./schooStaticEdit.vue?vue&type=template&id=de93dc5c"
import script from "./schooStaticEdit.vue?vue&type=script&lang=js"
export * from "./schooStaticEdit.vue?vue&type=script&lang=js"
import style0 from "./schooStaticEdit.vue?vue&type=style&index=0&id=de93dc5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports